import { call, put } from 'redux-saga/effects';
import { setMovimientosBancarios, savedMovimientoBancario } from '../../ducks/movimientosBancarios';
import { requestLoadMovimientosBancarios, requestSaveMovimientoBancario } from '../requests/movimientosBancarios';

export function* handleLoadMovimientosBancarios(action) {
    try {
        const response = yield call(requestLoadMovimientosBancarios, action.idBanco, action.idCuenta);
        const { data } = response;
        yield put(setMovimientosBancarios(data));
    } catch (error) {
        console.log(error);
    }
}

export function* handleSaveMovimientoBancario(action) {
    try {
        const response = yield call(requestSaveMovimientoBancario, action.movimientoBancario);
        const { data } = response;
        yield put(savedMovimientoBancario(data));
    } catch (error) {
        console.log(error);
    }
}
